import * as React from "react";
import { LocalAudioTrack, RemoteAudioTrack } from "twilio-video";

interface Props {
	track: LocalAudioTrack | RemoteAudioTrack;
}
export const AudioTrack = (props: Props) => {
	const ref = React.useRef<HTMLAudioElement>(null!);
	React.useEffect(() => {
		props.track.attach(ref.current);
	}, [props.track]);
	return <audio ref={ref} autoPlay />;
};
